import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var HorizontalBarChart03 = function HorizontalBarChart03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13 9.5V6.1c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.2401 4.5 11.9601 4.5 11.4 4.5H3m14 10v-3.4c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437C16.2401 9.5 15.9601 9.5 15.4 9.5H3M3 2v20m0-2.5h16.4c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 18.7401 21 18.4601 21 17.9v-1.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109H3z"
    })
  }));
};
export default HorizontalBarChart03;